// ==============================
// Imports
// ==============================

// Libraries
import AppBarSpacer from '../components/common/AppBarSpacer';
import { useState } from 'react';

// Local components
import MiniDrawer from '../components/MiniDrawer';
import PageHeader from '../components/common/PageHeader';
import CoachTable from '../components/CoachTable';
import { useTranslation } from '../i18n';

const CoachLayout = () => {
  const { t } = useTranslation();
  // States
  const [open, setOpen] = useState(true);

  // ==============================
  // Render
  // ==============================
  return (
    <>
      <div className="flex h-screen">
        {/* Sidebar */}
        <MiniDrawer open={open} setOpen={setOpen} />

        {/* Main content */}
        <main className="flex-1 overflow-auto app-page-bg">
          {/* Offset for fixed AppBar (height = 64px) */}
          <AppBarSpacer />

          <div className="h-full px-6 py-4">
            <PageHeader
              title={t('coach.pageTitle')}
              subtitle={t('coach.pageSubtitle')}
            />
            {/* Coach table */}
            <CoachTable />
          </div>
        </main>
      </div>
    </>
  );
};

export default CoachLayout;
